import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import happilyLogo from '../assets/happily-logo.png';

interface Props {
  /** A reload: the brand frame alone, with the logo only if startup runs slow. */
  quiet?: boolean;
  exiting: boolean;
  onFinished: () => void;
}

const SPLASH_EXIT_DURATION_MS = 240;

export default function SplashScreen({ quiet = false, exiting, onFinished }: Props) {
  const { t } = useTranslation('common');
  useEffect(() => {
    if (exiting) {
      const timer = setTimeout(onFinished, SPLASH_EXIT_DURATION_MS);
      return () => clearTimeout(timer);
    }
  }, [exiting, onFinished]);

  return (
    <div className={`splash-screen ${quiet ? 'splash-quiet' : ''} ${exiting ? 'splash-exit' : ''}`}>
      {/* Ambient glow orbs */}
      <div className="splash-orb splash-orb-1" />
      <div className="splash-orb splash-orb-2" />
      <div className="splash-orb splash-orb-3" />

      {/* Content */}
      <div className="splash-content">
        {/* Logo with glow ring */}
        <div className="splash-logo-container">
          <div className="splash-logo-ring" />
          <img
            src={happilyLogo}
            alt="Happily"
            className="splash-logo"
            draggable={false}
          />
        </div>

        {/* Brand name */}
        <div className="splash-text">
          <span className="splash-brand">{t('splashTitle')}</span>
          <span className="splash-sub">{t('splashSubtitle')}</span>
        </div>

        {/* Loading indicator */}
        <div className="splash-loader">
          <div className="splash-loader-track">
            <div className="splash-loader-fill" />
          </div>
        </div>
      </div>
    </div>
  );
}
